import { Button, Grid, Link, Typography } from "@mui/material";
import React from "react";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";

const ExeptionPage = ({ resetErrorBoundary }: any) => {
  return (
    <>
      <Grid
        container
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
        height={"100vh"}
        gap={"20px"}
      >
        <Grid item>
          <ReportGmailerrorredIcon style={{ fontSize: "80px" }} />
        </Grid>
        <Grid item>
          <Typography fontSize={"24px"} marginBottom={"10px"}>
            متاسفانه مشکلی بوجود آمده!
          </Typography>
          <Typography fontSize={"20px"}>
            به صفحه اصلی سامانه برمیگردید
          </Typography>
        </Grid>

        <Grid item sx={{ cursor: "pointer" }} className="lds-facebook">
          <div></div>
          <div></div>
          <div></div>
          {/* <button onClick={resetErrorBoundary}>بازگشت به سامانه</button> */}

          {/* <a href="/welcome">Link</a> */}
        </Grid>
      </Grid>
    </>
  );
};

export default ExeptionPage;
